import { FilestackImageData, FilestackImageFit } from 'api/types/shared.types';
import { getImageSrc } from 'utils/getImageSrc';

import { getFilestackImageFormat } from './getFilestackImageFormat';

type Props = {
  data: FilestackImageData | undefined;
  quality: 'high' | 'medium' | undefined;
  fit?: FilestackImageFit;
  width: number | undefined;
  height: number | undefined;
};

export function getFilestackImageSrc({
  data,
  fit,
  quality,
  width,
  height,
}: Props): {
  src: string;
  srcSet: string;
} {
  if (!data) return { src: '', srcSet: '' };

  const qualityNumber = quality === 'high' ? 100 : 70;

  const format = getFilestackImageFormat(data.mimetype);

  const img1x = getImageSrc({
    handle: data.handle,
    width,
    height,
    format,
    fit,
    quality: qualityNumber,
    mimetype: data.mimetype,
  });

  if (!width && !height) return { src: img1x, srcSet: img1x };

  const img2x = getImageSrc({
    handle: data.handle,
    width: width ? width * 2 : undefined,
    height: height ? height * 2 : undefined,
    format,
    fit,
    quality: qualityNumber,
    mimetype: data.mimetype,
  });

  const srcSet = `${img1x}, ${img2x} 2x`;

  return { src: img1x, srcSet };
}
